const currencyFormatter = ({decimals}) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: decimals,
});

const percentageFormatter = new Intl.NumberFormat('default', {
  style: 'percent',
  // Up to 2 decimals so rates match their source (e.g. HCP "28.57%"). Clean
  // integers (50%, 26%) still render without trailing zeros.
  maximumFractionDigits: 2,
});

export const formatCurrency = (value, decimals = 0) => currencyFormatter({decimals}).format(value);
export const formatPercent = (value) => percentageFormatter.format(value);
export const formatNumber = (value, kind) => {
  const n = Number(value);
  if (Number.isNaN(n)) return "0";

  if (kind === "$") {
    const hasFraction = Math.abs(n % 1) >= 0.005;
    return formatCurrency(n, hasFraction ? 2 : 0);
  }
  if (kind === "%") {
    return formatPercent(n);
  }

  const rounded = Math.round(n * 100) / 100;
  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
    maximumFractionDigits: 2,
  });
};
export const formatForUrl = (value) => value? value.trim().toLowerCase().replace(/[\s]+/g, "-") : "";